(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    let frame;

    const alignMenus = () => {
      document.querySelectorAll('.mega-menu[data-align-to-trigger]').forEach((menu) => {
        const trigger = menu.closest('details')?.querySelector('summary');
        if (!trigger) return;

        if (window.matchMedia('(min-width: 1000px)').matches) {
          const bounds = trigger.getBoundingClientRect();
          const offset = document.documentElement.dir === 'rtl'
            ? document.documentElement.clientWidth - bounds.right
            : bounds.left;
          menu.style.setProperty('--dm-mega-menu-gutter', `${Math.max(0, offset)}px`);
        } else {
          menu.style.removeProperty('--dm-mega-menu-gutter');
        }
      });
    };

    const scheduleAlignment = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(alignMenus);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleAlignment, { once: true });
    } else {
      scheduleAlignment();
    }

    document.fonts?.ready.then(scheduleAlignment);
    window.addEventListener('resize', scheduleAlignment, { passive: true });
    document.addEventListener('shopify:section:load', scheduleAlignment);
  })();
  } catch(e) { console.error(e); }
})();

})();
